const optionsObjectToList = (obj) => {
  return Object.keys(obj).map((key) => {
    return obj[key];
  })
}

export {
  optionsObjectToList
}